import React, { useState, useEffect } from "react";
import { message } from "antd";
import { api } from "../../../services/backend/api";
import CohortViewsView from "./CohortViewsView";

const cohort_views_types = [
  {
    id: "application_received_date",
    name: "By App Received Date",
  },
  {
    id: "active_on_project_date",
    name: "By Active Date",
  },
];

/** Default matches backend: weekly aggregates from unified_cp_roster_productivity. */
const DEFAULT_GRANULARITY = "weekly";

const CohortViews = ({ projectId, objectiveId, timeframeDateRange = {} }) => {
  const [cohortViews, setCohortViews] = useState([]);
  const [granularity, setGranularity] = useState(DEFAULT_GRANULARITY);
  const [cohortViewsLoading, setCohortViewsLoading] = useState(false);

  useEffect(() => {
    if (!projectId && !objectiveId) {
      setCohortViews([]);
      return;
    }
    const { start, end } = timeframeDateRange;
    if (!start || !end) {
      setCohortViews([]);
      return;
    }

    let cancelled = false;
    setCohortViewsLoading(true);

    const base = objectiveId
      ? `/performance/po/${objectiveId}/cohort-views`
      : `/performance/p/${projectId}/cohort-views`;

    Promise.all(
      cohort_views_types.map((view) =>
        api.get(
          `${base}?type=${encodeURIComponent(view.id)}&start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}&granularity=${encodeURIComponent(granularity)}`,
        ),
      ),
    )
      .then((results) => {
        if (!cancelled) {
          setCohortViews(results.filter(Boolean));
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error("Error loading cohort views:", err);
          message.error("Failed to load cohort views");
          setCohortViews([]);
        }
      })
      .finally(() => {
        if (!cancelled) setCohortViewsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [projectId, objectiveId, timeframeDateRange, granularity]);

  return (
    <CohortViewsView
      cohortViews={cohortViews}
      cohortViewsLoading={cohortViewsLoading}
      granularity={granularity}
      onGranularityChange={setGranularity}
      level={objectiveId ? "po" : "p"}
    />
  );
};

export default CohortViews;
